module.exports = __webpack_public_path__ + "static/media/BrixSans-Medium.0d8c7116.woff2";